import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { first } from 'rxjs/operators';

import { RootState } from '@root/app.state';
import * as CoreActions from '@core/core.actions';
import { go } from '@platform/router.actions';
import { RouteGuard } from '@platform/routing/route.guard';
import { ResourceState, ResourceStatuses } from '@platform/shared/resource.state';
import { selectUserOverview } from '@core/core.selectors';
import { UserOverview } from '@core/core.state';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserListGuard implements RouteGuard {
  constructor(private store$: Store<RootState>) {}

  async canActivate(): Promise<boolean> {
    return await this.preload();
  }

  async canActivateChild(): Promise<boolean> {
    return await this.preload();
  }

  private async preload(): Promise<boolean> {
    const userState = await this.loadAndWaitForUsers();

    const canActivate = userState.status === ResourceStatuses.SUCCEEDED;
    if (!canActivate) {
      this.store$.dispatch(go({ path: ['error'] }));
    }

    return canActivate;
  }

  private async loadAndWaitForUsers(): Promise<ResourceState<UserOverview[]>> {
    this.store$.dispatch(CoreActions.loadUserOverview());

    return await firstValueFrom(
      this.store$.pipe(
        select(selectUserOverview),
        first((x) => x.status === ResourceStatuses.FAILED || x.status === ResourceStatuses.SUCCEEDED),
      ),
    );
  }
}
